// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'box-3';

export const Component = () => (
  <path d='M2.005 10.005h4.886v4.886H2.005v-4.886Zm5.892 5.892V9H1v6.897h6.897Zm1.963-5.892h4.885v4.886H9.86v-4.886Zm5.89 5.892V9H8.855v6.897h6.897Zm1.965-5.892H22.6v4.886h-4.885v-4.886Zm5.89 5.892V9H16.71v6.897h6.896Z' />
);

export const viewBox = '0 0 25 25';
